import React from "react";
import HomeTop from "./HomeTop";
import { Box, useMediaQuery } from "@mui/material";
import HomeBottom from "./HomeBottom";
import Footer from "../Footer/Footer";

const Home = () => {
  const smallerThan600 = useMediaQuery("(min-width:600px)");
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
        /* flexWrap: "wrap", */
        height: smallerThan600 ? "calc(100lvh)" : "unset", //161 is addition of height and footer
        /*  overflowY: "auto", */
      }}
      className={"home"}
    >
      <HomeTop />
      <HomeBottom />
    </Box>
  );
};

export default Home;
